import React from 'react';
import Loader from 'modules/Common/Loader';

const t = {
  loading: 'Loading tasks',
  loadingMore: 'Loading more',
};

const ListLoader = ({ className, loadingMore }) => {
  return (
    <div className={className}>
      <Loader text={loadingMore ? t.loadingMore : t.loading} skin="white" />
    </div>
  );
};

export default ListLoader;
